import {useState, useEffect} from 'react';
import {BsFillGearFill, BsPeopleFill} from "react-icons/bs";
import {FontSizeChanger} from "../Components/FontSizeChanger";
import {ThemeSwitcher} from "../Components/ThemeSwitcher";
import {ClearAllStorage} from "../Components/ClearAllStorage"
import {dataLoaderService} from "../../features/player_scenario/services/dataLoaderService";
import {useAuthStore} from "../hooks/useAuthStore";
import {BiLogIn, BiLogOut} from "react-icons/bi";


const useNavLinksConfig = () => {
    const [groups, setGroups] = useState([]);
    const {isAuthorized, logout} = useAuthStore();

    useEffect(() => {
        const loadGroups = async () => {
            const data = await dataLoaderService.getAllGroups();
            setGroups(data || []);
        };
        loadGroups();
    }, [isAuthorized]);

    const generateLessonsMenu = (lessons, fileId) => {
        return lessons.map((item, index) => ({
            title: item.title,
            path: `/english/${fileId}-${index}/english_2`,
            permission: ["admin", "manager", "user"]
        }));
    };

    const dynamicMenuItems = groups.map(group => ({
        title: group.name,
        children: generateLessonsMenu(group.lessons, group.id)
    }));

    const menuItemsConfig = [
        {
            title: isAuthorized ? "Logout" : "Login",
            icon: isAuthorized ? BiLogOut : BiLogIn,
            props: {className: "icon"},
            path: isAuthorized ? null : '/login',
            action: isAuthorized ? logout : null,
            permission: ["admin", "manager", "user"]
        },
        {
            title: "Test speech synthesis",
            icon: BsPeopleFill,
            props: {className: "icon"},
            path: '/test',
            permission: ["admin", "manager"]
        },

        ...dynamicMenuItems,

        {
            title: "Games",
            icon: BsPeopleFill,
            props: {className: "icon"},
            children: [
                {
                    title: "Trusty",
                    path: '/game/trusty/global',
                    permission: ["admin", "manager"]
                }
            ]
        },

        {
            title: "Settings",
            group: "footer",
            icon: BsFillGearFill,
            props: {className: "icon"},
            children: [
                {
                    title: "theme",
                    component: ThemeSwitcher,
                    props: {size: "1.5rem", width: "4rem"}
                },
                {
                    component: ClearAllStorage,
                },
                {
                    component: FontSizeChanger,
                },

            ]
        },
    ];

    return menuItemsConfig
}
export {useNavLinksConfig};
